 
import { createSlice } from '@reduxjs/toolkit';
import {
  SettingsState,
  SetSidebarCollapsedAction,
  SetDarkModeAction,
  SetBusinessVersionAction,
} from './settings.types';
import { createSliceHook } from '../helpers';

const initialState: SettingsState = {
  initialized: true,
  darkMode: false,
  sidebarCollapsed: false,
  businessVersion: '',
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setDarkMode: (state, action: SetDarkModeAction) => {
      state.darkMode = action.payload;
    },
    toggleSidebarCollapsed: state => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed: (state, action: SetSidebarCollapsedAction) => {
      state.sidebarCollapsed = action.payload;
    },
    setBusinessVersion: (state, action: SetBusinessVersionAction) => {
      state.businessVersion = action.payload;
    },
  },
});

export const { setSidebarCollapsed, toggleSidebarCollapsed } =
  settingsSlice.actions;

export const actions = {
  ...settingsSlice.actions,
};

export const useSettingsSlice = createSliceHook(settingsSlice.name, actions);
